export default "__VITE_ASSET__Cxi$nXBq__"